export default [
    {
        path: "/admin",
        name: "admin",
        redirect: "/admin/dashboard",
        component: () => import("@/components/admin/layout/Layout.vue"),
        meta: {
            adminAuth: true,
            providerAuth: false
        },
        children: [
            {
                path: '/admin/dashboard',
                name: 'admin-dashboard',
                component: () => import('@/components/admin/pages/Dashboard.vue'),
                meta: {
                    title: 'Dashboard',
                }
            },
            {
                path: '/admin/change-password/:id',
                name: 'change-password',
                component: () => import('@/components/admin/pages/ChangePassword.vue'),
                meta: {
                    title: 'Change Password',
                }
            },

            {
                path: '/admin/inbox',
                name: 'admin-inbox',
                component: () => import('@/components/admin/pages/inbox/Inbox.vue'),
                meta: {
                    title: 'Inbox',
                }
            },
            {
                path: '/admin/logs',
                name: 'admin-log',
                component: () => import('@/components/admin/pages/Log.vue'),
                meta: {
                    title: 'Logs',
                }
            },
            {
                path: '/admin/support-response/:supportId',
                name: 'support-response',
                component: () => import('@/components/admin/pages/support-response/SupportResponse.vue'),
                meta: {
                    title: 'Support Response',
                }
            },
            {
                path: '/admin/general-settings',
                name: 'general-settings',
                component: () => import('@/components/admin/pages/general-settings/GeneralSettings.vue'),
                meta: {
                    title: 'General Settings',
                }
            },
            {
                path: '/admin/inbox/:id',
                name: 'admin-inbox-details',
                component: () => import('@/components/admin/pages/inbox/InboxDetails.vue'),
                meta: {
                    title: 'Inbox Details',
                }
            },

            /*Offer and discount coupons code*/
            {
                path: '/admin/discount-coupons',
                name: 'discount-coupons',
                component: () => import('@/components/admin/pages/discount-coupons/DiscountCoupons.vue'),
                meta: {
                    title: 'discount-coupons',
                }
            },
            {
                path: '/admin/add-discount-coupons',
                name: 'add-discount-coupons',
                component: () => import('@/components/admin/pages/discount-coupons/AddDiscountCoupons.vue'),
                meta: {
                    title: 'Add Discount Coupons',
                }
            },
            {
                path: '/admin/edit-discount-coupons/:id',
                name: 'edit-discount-coupons',
                component: () => import('@/components/admin/pages/discount-coupons/EditDiscountCoupons.vue'),
                meta: {
                    title: 'Edit Discount Coupons',
                }
            },
            // Providers
            {
                path: '/admin/producers',
                name: 'producers',
                component: () => import('@/components/admin/pages/producer/Producers.vue'),
                meta: {
                    title: 'List Producers',
                }
            },
            {
                path: '/admin/producer-details/:id',
                name: 'producer-details',
                component: () => import('@/components/admin/pages/producer/ProducerDetails.vue'),
                meta: {
                    title: 'Producer Details',
                }
            },
            {
                path: '/admin/add-producer',
                name: 'add-producer',
                component: () => import('@/components/admin/pages/producer/AddProducer.vue'),
                meta: {
                    title: 'Add Producer',
                }
            },
            {
                path: '/admin/edit-producer/:id',
                name: 'edit-producer',
                component: () => import('@/components/admin/pages/producer/EditProducer.vue'),
                meta: {
                    title: 'Edit Producer',
                }
            },
            {
                path: '/admin/edit-general-setting/:id',
                name: 'edit-general-setting',
                component: () => import('@/components/admin/pages/producer/EditProducerGeneralSetting.vue'),
                meta: {
                    title: 'Edit Producer',
                }
            },
            {
                path: '/admin/producer-products/:id',
                name: 'producer-products',
                component: () => import('@/components/admin/pages/producer/ProducerProducts.vue'),
                meta: {
                    title: 'Producer Products',
                }
            },
            
            {
                path: "/admin/dealer-product-details/:dealerId/:productId",
                name: 'dealer-product-details',
                component: () => import('@/components/admin/pages/producer/ProducerProductDetails.vue'),
                meta: {
                    title: 'dealer Product Details',
                }
            },

            // replica-handler
            {
                path: '/admin/manage/producers',
                name: 'manage-producers',
                component: () => import('@/components/admin/pages/manage-producer/Producer.vue'),
                meta: {
                    title: 'List Producers',
                }
            },
            {
                path: '/admin/manage/add-producer',
                name: 'manage-add-producer',
                component: () => import('@/components/admin/pages/manage-producer/AddProducer.vue'),
                meta: {
                    title: 'Add Producer',
                }
            },
            {
                path: '/admin/manage/edit-producer/:id',
                name: 'manage-edit-producer',
                component: () => import('@/components/admin/pages/manage-producer/EditProducer.vue'),
                meta: {
                    title: 'Edit Producer',
                }
            },
            {
                path: '/admin/manage/edit-general-setting/:id',
                name: 'manage-edit-general-setting',
                component: () => import('@/components/admin/pages/manage-producer/EditProducerGeneralSetting.vue'),
                meta: {
                    title: 'Edit Producer',
                }
            },
            {
                path: '/admin/manage/producer-details/:id',
                name: 'manage-producer-details',
                component: () => import('@/components/admin/pages/manage-producer/ProducerDetails.vue'),
                meta: {
                    title: 'Producer Details',
                }
            },
           

            //Newsletter
            {
                path: '/admin/newsletters',
                name: 'newsletters',
                component: () => import('@/components/admin/pages/newsletters/Newsletters.vue'),
                meta: {
                    title: 'List Newsletters',
                }
            },

            // Orders
            {
                path: '/admin/orders',
                name: 'orders',
                component: () => import('@/components/admin/pages/orders/Orders.vue'),
                meta: {
                    title: 'List Orders',
                }
            },
            {
                path: '/admin/order/:id',
                name: 'order-details',
                component: () => import('@/components/admin/pages/orders/OrderDetails.vue'),
                meta: {
                    title: 'Order Details',
                }
            },

            // Customers
            {
                path: '/admin/customers',
                name: 'customers',
                component: () => import('@/components/admin/pages/customer/Customers.vue'),
                meta: {
                    title: 'List Customers',
                }
            },
            {
                path: '/admin/customer-details/:id',
                name: 'customer-details',
                component: () => import('@/components/admin/pages/customer/CustomerDetails.vue'),
                meta: {
                    title: 'Customer Details',
                }
            },
            {
                path: '/admin/add-customer',
                name: 'add-customer',
                component: () => import('@/components/admin/pages/customer/AddCustomer.vue'),
                meta: {
                    title: 'Add Customer',
                }
            },
            {
                path: '/admin/edit-customer/:id',
                name: 'edit-customer',
                component: () => import('@/components/admin/pages/customer/EditCustomer.vue'),
                meta: {
                    title: 'Edit Customer',
                }
            },

            // Room Categories
            /*{
                path: '/admin/room-categories',
                name: 'room-categories',
                component: () => import('@/components/admin/pages/category/Categories.vue'),
                meta: {
                    title: 'List Categories',
                }
            },
            {
                path: '/admin/add-room-category',
                name: 'add-category',
                component: () => import('@/components/admin/pages/category/AddCategory.vue'),
                meta: {
                    title: 'Add Category',
                }
            },
            {
                path: '/admin/edit-room-category/:id',
                name: 'edit-category',
                component: () => import('@/components/admin/pages/category/EditCategory.vue'),
                meta: {
                    title: 'Edit Category',
                }
            },*/

            // Product Categories
            {
                path: '/admin/product-categories',
                name: 'product-categories',
                component: () => import('@/components/admin/pages/category/Categories.vue'),
                meta: {
                    title: 'List Categories',
                }
            },
            {
                path: '/admin/add-product-category',
                name: 'add-category',
                component: () => import('@/components/admin/pages/category/AddCategory.vue'),
                meta: {
                    title: 'Add Category',
                }
            },
            {
                path: '/admin/edit-product-category/:id',
                name: 'edit-category',
                component: () => import('@/components/admin/pages/category/EditCategory.vue'),
                meta: {
                    title: 'Edit Category',
                }
            },

            // Product Certificates
            {
                path: '/admin/product-certificates',
                name: 'product-certificates',
                component: () => import('@/components/admin/pages/product-certificates/Certificates.vue'),
                meta: {
                    title: 'List Certificates',
                }
            },
            {
                path: '/admin/add-product-certificate',
                name: 'add-certificate',
                component: () => import('@/components/admin/pages/product-certificates/AddCertificate.vue'),
                meta: {
                    title: 'Add Certificate',
                }
            },
            {
                path: '/admin/edit-product-certificate/:id',
                name: 'edit-certificate',
                component: () => import('@/components/admin/pages/product-certificates/EditCertificate.vue'),
                meta: {
                    title: 'Edit Certificate',
                }
            },

            // Product Information
            {
                path: '/admin/product-info',
                name: 'product-info',
                component: () => import('@/components/admin/pages/product-information/Informations.vue'),
                meta: {
                    title: 'List Information',
                }
            },
            {
                path: '/admin/add-product-info',
                name: 'add-product-info',
                component: () => import('@/components/admin/pages/product-information/AddInformation.vue'),
                meta: {
                    title: 'Add Information',
                }
            },
            {
                path: '/admin/edit-product-info/:id',
                name: 'edit-product-info',
                component: () => import('@/components/admin/pages/product-information/EditInformation.vue'),
                meta: {
                    title: 'Edit Information',
                }
            },

            // Product Features
            {
                path: '/admin/product-features',
                name: 'product-features',
                component: () => import('@/components/admin/pages/product-features/Features.vue'),
                meta: {
                    title: 'List Features',
                }
            },
            {
                path: '/admin/add-product-feature',
                name: 'add-product-feature',
                component: () => import('@/components/admin/pages/product-features/AddFeature.vue'),
                meta: {
                    title: 'Add Feature',
                }
            },
            {
                path: '/admin/edit-product-feature/:id',
                name: 'edit-product-feature',
                component: () => import('@/components/admin/pages/product-features/EditFeature.vue'),
                meta: {
                    title: 'Edit Feature',
                }
            },

            // Payment Options
            {
                path: '/admin/payment-options',
                name: 'payment-options',
                component: () => import('@/components/admin/pages/payment-options/Options.vue'),
                meta: {
                    title: 'List Payment Options',
                }
            },
            {
                path: '/admin/add-payment-option',
                name: 'add-payment-option',
                component: () => import('@/components/admin/pages/payment-options/AddOption.vue'),
                meta: {
                    title: 'Add Payment Option',
                }
            },
            {
                path: '/admin/edit-payment-option/:id',
                name: 'edit-payment-option',
                component: () => import('@/components/admin/pages/payment-options/EditOption.vue'),
                meta: {
                    title: 'Edit Payment Option',
                }
            },

            // Blog Categories
            {
                path: '/admin/blog-categories',
                name: 'blog-categories',
                component: () => import('@/components/admin/pages/blog-category/Categories.vue'),
                meta: {
                    title: 'List Categories',
                }
            },
            {
                path: '/admin/add-blog-category',
                name: 'add-blog-category',
                component: () => import('@/components/admin/pages/blog-category/AddCategory.vue'),
                meta: {
                    title: 'Add Category',
                }
            },
            {
                path: '/admin/edit-blog-category/:id',
                name: 'edit-blog-category',
                component: () => import('@/components/admin/pages/blog-category/EditCategory.vue'),
                meta: {
                    title: 'Edit Category',
                }
            },

            // Blogs
            {
                path: '/admin/blogs',
                name: 'blogs',
                component: () => import('@/components/admin/pages/blog/Blogs.vue'),
                meta: {
                    title: 'List Blogs',
                }
            },
            {
                path: '/admin/add-blog',
                name: 'add-blog',
                component: () => import('@/components/admin/pages/blog/AddBlog.vue'),
                meta: {
                    title: 'Add Blog',
                }
            },
            {
                path: '/admin/edit-blog/:id',
                name: 'edit-blog',
                component: () => import('@/components/admin/pages/blog/EditBlog.vue'),
                meta: {
                    title: 'Edit Blog',
                }
            },

            // Rooms
             /*{
                path: '/admin/rooms',
                name: 'rooms',
                component: () => import('@/components/admin/pages/room/Rooms.vue'),
                meta: {
                    title: 'All Rooms',
                }
            },
            {
                path: '/admin/edit-room/:id',
                name: 'edit-room',
                component: () => import('@/components/admin/pages/room/EditRoom.vue'),
                meta: {
                    title: 'Edit Room',
                }
            },
            {
                path: '/admin/all-provider-rooms',
                name: 'provider-rooms',
                component: () => import('@/components/admin/pages/room/ProviderRooms.vue'),
                meta: {
                    title: 'All Rooms',
                }
            },
            {
                path: '/admin/provider-room/:id',
                name: 'provider-room-details',
                component: () => import('@/components/admin/pages/room/ProviderRoomDetails.vue'),
                meta: {
                    title: 'Provider Room Details',
                }
            },
           {
                path: '/admin/add-room',
                name: 'add-room',
                component: () => import('@/components/admin/pages/room/AddRoom.vue'),
                meta: {
                    title: 'Add Room',
                }
            },*/
            // product
            {
                path: '/admin/products',
                name: 'products',
                component: () => import('@/components/admin/pages/product/adminProduct/Products.vue'),
                meta: {
                    title: 'All Products',
                }
            },
            {
                path: '/admin/dealer-products',
                name: 'dealer-products',
                component: () => import('@/components/admin/pages/product/Products.vue'),
                meta: {
                    title: 'All Products',
                }
            },
            {
                path: '/admin/all-dealer-products',
                name: 'all-dealer-products',
                component: () => import('@/components/admin/pages/product/DealerProducts.vue'),
                meta: {
                    title: 'All Dealer Products',
                }
            },
            {
                path: '/admin/add-product',
                name: 'add-product',
                component: () => import('@/components/admin/pages/product/adminProduct/AddProduct.vue'),
                meta: {
                    title: 'Add Product',
                }
            },
            {
                path: '/admin/add-dealer-product',
                name: 'add-dealer-product',
                component: () => import('@/components/admin/pages/product/AddProduct.vue'),
                meta: {
                    title: 'Add Product',
                }
            },

            {
                path: '/admin/edit-product/:id',
                name: 'edit-product',
                component: () => import('@/components/admin/pages/product/adminProduct/EditProduct.vue'),
                meta: {
                    title: 'Edit Product',
                }
            },
            {
                path: '/admin/edit-dealer-product/:id',
                name: 'edit-dealer-product',
                component: () => import('@/components/admin/pages/product/EditProduct.vue'),
                meta: {
                    title: 'Edit Product',
                }
            },


            // Badges
            {
                path: '/admin/product-badges',
                name: 'badges',
                component: () => import('@/components/admin/pages/badges/Badges.vue'),
                meta: {
                    title: 'All Badges',
                }
            },
            {
                path: '/admin/add-badge',
                name: 'add-badge',
                component: () => import('@/components/admin/pages/badges/AddBadge.vue'),
                meta: {
                    title: 'Add Badge',
                }
            },
            {
                path: '/admin/edit-badge/:id',
                name: 'edit-badge',
                component: () => import('@/components/admin/pages/badges/EditBadge.vue'),
                meta: {
                    title: 'Edit Badge',
                }
            },

            // Delivery Options
            {
                path: '/admin/delivery-options',
                name: 'delivery-options',
                component: () => import('@/components/admin/pages/delivery-options/Options.vue'),
                meta: {
                    title: 'All Options',
                }
            },
            {
                path: '/admin/add-delivery-option',
                name: 'add-delivery-option',
                component: () => import('@/components/admin/pages/delivery-options/AddOption.vue'),
                meta: {
                    title: 'Add Option',
                }
            },
            {
                path: '/admin/edit-delivery-option/:id',
                name: 'edit-delivery-option',
                component: () => import('@/components/admin/pages/delivery-options/EditOption.vue'),
                meta: {
                    title: 'Edit Option',
                }
            },

            // CMS
            {
                path: '/admin/cms/about-page',
                name: 'add-equipment',
                component: () => import('@/components/admin/pages/cms/About.vue'),
                meta: {
                    title: 'CMS About Page',
                }
            },

            // FAQ
            {
                path: '/admin/faq',
                name: 'faq',
                component: () => import('@/components/admin/pages/faq/Faq.vue'),
                meta: {
                    title: 'FAQ',
                }
            },
            {
                path: '/admin/add-faq',
                name: 'add-faq',
                component: () => import('@/components/admin/pages/faq/AddFaq.vue'),
                meta: {
                    title: 'Add FAQ',
                }
            },
            {
                path: '/admin/edit-faq/:id',
                name: 'edit-faq',
                component: () => import('@/components/admin/pages/faq/EditFaq.vue'),
                meta: {
                    title: 'Edit FAQ',
                }
            },
            // Invoices
            {
                path: '/admin/invoices',
                name: 'invoices',
                component: () => import('@/components/admin/pages/invoice/Invoices.vue'),
                meta: {
                    title: 'All Invoices',
                }
            },

            // Documents
            {
                path: '/admin/documentation',
                name: 'documentation',
                component: () => import('@/components/admin/pages/documents/Documents.vue'),
                meta: {
                    title: 'Documentation',
                }
            },
            {
                path: '/admin/add-document',
                name: 'add-document',
                component: () => import('@/components/admin/pages/documents/AddDocument.vue'),
                meta: {
                    title: 'Add Document',
                }
            },
            {
                path: '/admin/edit-document/:id',
                name: 'edit-document',
                component: () => import('@/components/admin/pages/documents/EditDocument.vue'),
                meta: {
                    title: 'Edit Document',
                }
            },
        ]
    }
]
